import ValueFormatter from 'product_modules/utils/valueFormatters/base/Types';
import ValueFormattingError from 'product_modules/utils/valueFormatters/base/ValueFormattingError';
import { DateVisualAttributes } from 'product_modules/api/Core/VariablesApi';
import { DateVisualDataType } from 'product_modules/enums/VisualDataType';
import getValueVisualTypeCorrespondenceChecker from 'product_modules/utils/valueVisualTypeCorrespondenceCheckers';
import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from './base/constants';

export const getFormattedDate = (variableValue: string, dateFormat: string) => {
  const UTCFormatDate = moment(variableValue, DEFAULT_DATE_FORMAT).toDate();

  return moment(UTCFormatDate).format(dateFormat);
};

const isDateValue = getValueVisualTypeCorrespondenceChecker(DateVisualDataType.Date);

const formatDateValue: ValueFormatter<DateVisualAttributes> = (
  value,
  params,
) => {
  if (!isDateValue(value)) {
    throw new ValueFormattingError();
  }

  const { dateFormat = DEFAULT_DATE_FORMAT } = params || {};

  return dateFormat ? getFormattedDate(value, dateFormat) : value;
};

export default formatDateValue;
